import { render, staticRenderFns } from "./BasicQuestion.vue?vue&type=template&id=28aa630d&"
import script from "./BasicQuestion.vue?vue&type=script&lang=js&"
export * from "./BasicQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports